import { Link } from 'react-router-dom';
import { newsList } from '@/mocks/news';

export default function NewsList() {
  const latest = newsList.slice(0, 6);

  return (
    <section className="w-full px-4 md:px-8 py-10 md:py-14 bg-background-100">
      <div className="flex items-end justify-between mb-6">
        <div>
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950">最新动漫资讯</h2>
          <p className="mt-1.5 text-sm text-foreground-500">掌握行业动态与新番消息</p>
        </div>
        <Link to="/news" className="inline-flex items-center gap-1 text-sm text-primary-600 hover:text-accent-600 transition-colors whitespace-nowrap cursor-pointer">
          更多资讯
          <i className="ri-arrow-right-s-line"></i>
        </Link>
      </div>

      <div className="space-y-3">
        {latest.map((item) => (
          <Link
            key={item.id}
            to={`/news/${item.id}`}
            className="group flex items-start gap-4 p-3 md:p-4 rounded-lg bg-background-50 border border-background-200 hover:border-primary-300 transition-colors cursor-pointer"
          >
            <span className="hidden sm:flex w-10 h-10 shrink-0 items-center justify-center rounded-lg bg-secondary-100 text-secondary-600 group-hover:bg-accent-500 group-hover:text-background-50 transition-colors">
              <i className="ri-article-line text-xl"></i>
            </span>
            <div className="min-w-0 flex-1">
              <h3 className="text-sm md:text-base font-semibold text-foreground-950 line-clamp-1 group-hover:text-primary-600 transition-colors">
                {item.title}
              </h3>
              <p className="mt-1 text-xs md:text-sm text-foreground-500 line-clamp-1">{item.summary}</p>
            </div>
            <div className="text-right shrink-0">
              <span className="text-xs text-foreground-400 whitespace-nowrap">{item.date}</span>
              <span className="block mt-1 text-xs text-secondary-600 whitespace-nowrap">{item.category}</span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}